import React, { Component } from 'react'
import DatePicker from "react-datepicker";
import request from "../../../lib/requester";
import _ from 'lodash'

class RejectPayment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      success: '',
      error: [],
      start_date: '',
      end_date: '',
      claim_number: '',
      lovClaim: [],
      ap_invoice_no: '',
      reject_reason: '',
      dataTable: [],
      selectedInvoice: [],
      selectedClaim: [],
      user: JSON.parse(window.localStorage.getItem('is_user'))
    }
  }

  componentDidMount = () => {

  }

  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}><i class="fas fa-exclamation-triangle" /> {item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  handle_start_date = (date) => {
    this.setState({ start_date: date })
  }

  handle_end_date = (date) => {
    this.setState({ end_date: date })
  }

  handleChangeInput = (e) => {
    let value = e.target.value
    let name = e.target.name

    this.setState({ [name]: value });
  }

  handleSearchClaim = () => {
    if (this.state.claim_number.length === 0) {
      alert('Claim number is required!')
      return false
    }

    let url = '/api/traces_chd/v1/payment/search-claim'
    let param = {
      claim_number: this.state.claim_number
    }
    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function (response) {
        let { data } = response.data
        if (data.length === 0) {
          alert('Claim Number not found OR claim has been processed')
          return false
        }
        this.setState({ lovClaim: data, selectedClaim: [data[0].claim_number], loading: false })
      }.bind(this),
      error: function (e) {
        console.log(e.message)
      }.bind(this)
    })
  }

  handleSearch = () => {
    if (this.state.ap_invoice_no.length === 0 && (!this.state.start_date || !this.state.end_date)) {
      alert('Filter to search invoice')
      return false
    }
    let url = '/api/traces_chd/v1/payment/search-invoice'
    let param = {
      ap_invoice_no: this.state.ap_invoice_no,
      start_date: this.state.start_date,
      end_date: this.state.end_date
    }

    request.postCHD(url, param, {
      success: function (response) {
        console.log(response)
        let { data } = response.data
        this.setState({ dataTable: data })
      }.bind(this),
      error: function (e) {
        console.log(e.message)
      }.bind(this)
    })
  }

  handleSubmit = () => {
    if (this.state.selectedClaim.length === 0) {
      this.setState({ error: ['Claim is required'] })
      return false
    }
    if (this.state.reject_reason.length === 0) {
      this.setState({ error: ['Reason is required'] })
      return false
    }
    if (window.confirm('Confirm reject claim?')) {
      let url = '/api/traces_chd/v1/payment/reject-by-claim'
      let param = {
        claim_no: this.state.claim_number,
        reason: this.state.reject_reason,
        claim: this.state.selectedClaim,
        email: this.state.user.username || '',
        requester: this.state.user.user_id || ''
      }
      request.postCHD(url, param, {
        success: function (response) {
          this.setState({ success: 'Claim has been rejected!' })
          window.scrollTo(0, 0)
          window.setTimeout(() => {
            window.location.reload()
          }, 3000)
        }.bind(this),
        error: function (e) {
          this.setState({ error: e.response.data.message || 'Error while submitting your request' })
          window.scrollTo(0, 0)
        }.bind(this)
      })
    }
  }

  handleClick = (e) => {
    let claim = e.target.attributes.getNamedItem("data-claim").value;
    let { selectedClaim } = this.state;
    let findIndex = _.findIndex(selectedClaim, function (o) {
      return o === claim;
    });
    if (findIndex < 0) {
      selectedClaim.push(claim)
    } else {
      selectedClaim.splice(findIndex, 1);
    }
    console.log(selectedClaim)
    this.setState(selectedClaim);
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-8">
                <div className="card card-info">
                  <div className="card-header"></div>
                  <div className="card-body">
                    {this.showNotification()}
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Claim Number</label>
                      <input type="text" className="col-md-5 form-control" name="claim_number" value={this.state.claim_number} onChange={this.handleChangeInput.bind(this)} />
                      <button className="btn btn-primary col-md-2 ml-3" onClick={this.handleSearchClaim.bind(this)}>Search</button>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <table className="table table-stripped table-sm table-bordered">
                          <thead className="thead-light">
                            <tr>
                              <th className="text-center">Claim Number</th>
                              <th className="text-center">Amount</th>
                            </tr>
                          </thead>
                          {
                            this.state.lovClaim.map((item, index) => (
                              <tr>
                                <td>{item.claim_number}</td>
                                <td className="text-right">{item.amount && item.amount > 0 ? item.amount.toLocaleString('de-DE', { minimumFractionDigits: 2 }) : 0}</td>
                              </tr>
                            ))
                          }
                        </table>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-3">Reason Reject</label>
                      <textarea className="form-control col-md-9" rows={5} value={this.state.reject_reason} name="reject_reason" onChange={this.handleChangeInput.bind(this)}></textarea>
                    </div>
                    <hr />
                    <div className="row">
                      <button className="btn btn-danger" onClick={this.handleSubmit.bind(this)}><i className="fa fa-times" /> Reject</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default RejectPayment